var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsEc2SvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M1.702 2.98L1 3.312v9.376l.702.332 2.842-4.777L1.702 2.98z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M3.339 12.657l-1.637.363V2.98l1.637.353v9.324z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M2.476 2.612l.863-.406 4.096 6.216-4.096 5.372-.863-.406V2.612z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M5.38 13.248l-2.041.546V2.206l2.04.548v10.494z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M4.3 1.75l1.08-.512 6.043 7.864-6.043 5.66-1.08-.511V1.749z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M7.998 13.856l-2.618.906V1.238l2.618.908v11.71z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M6.602.66L7.998 0l6.538 8.453L7.998 16l-1.396-.66V.66z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M15 12.686L7.998 16V0L15 3.314v9.372z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsEc2SvgrepoCom);
export default __webpack_public_path__ + "static/media/aws-ec2-svgrepo-com.9b8f619b43bec0a4993de7fa43cd5e6a.svg";
export { ForwardRef as ReactComponent };